import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react';
import { api, getToken, setToken } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(Boolean(getToken()));

  useEffect(() => {
    if (!getToken()) return;
    api.get('/auth/me')
      .then((r) => setUser(r.data))
      .catch(() => { setToken(null); setUser(null); })
      .finally(() => setChecking(false));
  }, []);

  const applyAuth = useCallback((data) => { setToken(data.token); setUser(data.user); return data.user; }, []);
  const login = useCallback(async (email, password) => applyAuth((await api.post('/auth/login', { email, password })).data), [applyAuth]);
  const register = useCallback(async (payload) => applyAuth((await api.post('/auth/register', payload)).data), [applyAuth]);
  const logout = useCallback(async () => {
    try { await api.post('/auth/logout'); } catch (e) { console.error('Logout failed', e); }
    setToken(null);
    setUser(null);
  }, []);

  const value = useMemo(() => ({ user, checking, login, register, logout, setUser }), [user, checking, login, register, logout]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};
